/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const Menu = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.Menu {...otherProps} className={className}>
      {children}
    </components.Menu>
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

Menu.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default Menu;
